import React from "react";
import "./featuresSection.css";
import { FaCalendarCheck, FaCapsules, FaFlask } from "react-icons/fa";

function FeaturesSection() {
  return (
    <section  id="features" className="features-section">
    <div className="features-section-header">
      <h2>Why Choose MediQNow?</h2>
      <p>Making healthcare simpler, faster, and more accessible for everyone.</p>
    </div>
  
    <div className="features-section-grid">
      <div className="features-section-card">
        <FaCalendarCheck className="features-section-icon" />
        <h3>Book Appointments</h3>
        <p>Instantly book consultations with hospitals, clinics, and doctors near you — no waiting, no hassle.</p>
      </div>
  
      <div className="features-section-card">
        <FaCapsules className="features-section-icon" />
        <h3>Order Medicines</h3>
        <p>Get your prescriptions delivered quickly from trusted medical shops in your area.</p>
      </div>
  
      <div className="features-section-card">
        <FaFlask className="features-section-icon" />
        <h3>Lab Test Scheduling</h3>
        <p>Book lab tests and receive results directly through the app — all from the comfort of your home.</p>
      </div>
    </div>
  </section>
  );
}

export default FeaturesSection;
